import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Manufacturing = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Manufacturing</h6>
          <hr />
          <h1 className="banner-title">
            Optimizing Manufacturing Processes with Advanced <br /> Software
            Solutions
          </h1>

          <p>
            Enhance operational efficiency, reduce costs, and increase
            productivity through data-driven solutions tailored to the
            manufacturing industry.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/two-colleagues-factory_1303-14331.jpg"
          alt="Manufacturing Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">Manufacturing</h6>
              <h2 className="text-center">
                Revolutionize Manufacturing with Smart Technologies
              </h2>
              <p className="text-center">
                In today’s competitive manufacturing landscape, integrating
                technology and automation is key to staying ahead. Our tailored
                software solutions help manufacturing companies optimize
                production, streamline supply chains, and drive efficiency with
                data-driven insights.
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Our Solutions</h2>
              <p className="text-center mb-0">
                From factory automation to predictive maintenance, we provide
                comprehensive software solutions that enhance productivity,
                minimize downtime, and maximize the potential of manufacturing
                operations.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Predictive Maintenance</a>
              </h3>
              <p className="mb-4">
                Our predictive maintenance software uses data analytics to
                predict machine failures before they happen, allowing
                manufacturers to perform maintenance only when necessary.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Supply Chain Optimization</a>
              </h3>
              <p className="mb-4">
                Our supply chain management software helps manufacturers
                optimize procurement, inventory management, and logistics to
                ensure products are delivered on time, at the right cost, and
                with maximum efficiency.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Real-time Analytics Dashboard</a>
              </h3>
              <p className="mb-4">
                Our real-time analytics dashboard provides manufacturers with
                immediate visibility into key production metrics, machine
                performance, and operational efficiency, empowering
                decision-makers to respond quickly to any issues.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Production Scheduling Software</a>
              </h3>
              <p className="mb-4">
                Our production scheduling software helps manufacturers
                streamline production timelines, allocate resources efficiently,
                and avoid bottlenecks, ensuring maximum throughput and on-time
                delivery of products.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">
                  Ready to Boost Your Manufacturing with Innovative Software?
                </h2>
                <p className="mt-3">
                  Let our technology solutions optimize your manufacturing
                  processes, improve efficiency, and reduce downtime, all while
                  providing real-time insights for better decision-making.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Manufacturing Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Manufacturing;
